import angular from 'angular';
import { error } from 'loglevel';
import moment from 'moment';

angular
  .module('cxInvoicing')
  .controller('TransactionDialogCtrl', [
    '$element',
    'transactionHttpSvc',
    'resourceFactorySvc',
    'flySvc',
    'openIbanSvc',
    'dataCache',
    'close',
    'transaction',
    'companyId',
    '$http',
    'appUrls',
    transactionDialogCtrl,
  ]);

function transactionDialogCtrl(
  $element,
  transactionHttpSvc,
  resourceFactorySvc,
  flySvc,
  openIbanSvc,
  dataCache,
  close,
  transaction,
  companyId,
  $http,
  appUrls,
) {
  var vm = this;
  vm.saving = false;
  vm.showValidation = false;
  vm.transactionIban = '';
  vm.bankAccounts = [];
  vm.transaction = transaction || {
    date: moment
      .utc()
      .startOf('day')
      .toDate(),
    amount: 0,
    name: '',
    iban: '',
    bic: '',
    description: '',
    companyId: companyId || dataCache.getDefaultCompany().id,
  };
  if (typeof vm.transaction.date === 'string')
    vm.transaction.date = new moment(vm.transaction.date).toDate();
  vm.companies = dataCache.getArray('company');

  const getCompanyBankAccounts = companyId => {
    $http.get(`${appUrls.api}/api/company/${companyId}/bankaccounts`).then(({ data }) => {
      vm.bankAccounts = data;

      const mainBankAccount = data.find(x => x.isMain);

      if (mainBankAccount && !vm.transaction.id) {
        vm.transaction.companyIBAN = mainBankAccount.bankAccountNr;
      }
    });
  };

  vm.companyChanged = function() {
    getCompanyBankAccounts(vm.transaction.companyId);
  };
  vm.companyChanged();

  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    if (vm.transaction.id) {
      transactionHttpSvc.updateTransaction(vm.transaction).then(
        function(result) {
          vm.saving = false;
          $element.modal('hide');
          close(result, 500);
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          vm.saving = false;
        },
      );
    } else {
      transactionHttpSvc.createTransaction(vm.transaction).then(
        function(result) {
          vm.saving = false;
          $element.modal('hide');
          close(result, 500);
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
    }
  };
  vm.cancel = function() {
    close(null, 500);
  };
  vm.getBic = function() {
    if (!vm.transaction.iban) return;

    //https://syneton.visualstudio.com/CloudX/_workitems/edit/13446
    //Temporarily disabled because iban service is down
    //openIbanSvc.getBic(vm.transaction.iban).then(function (bic) {
    //    if (bic)
    //        vm.transaction.bic = bic;
    //}, function (error) {
    //    if (error && error.code)
    //        flySvc.error(error.code, error.parameters);
    //});
  };
}
